import ApiRoutes from '~/config/api-routes';
import WebRoutes from '~/config/web-routes';
import {parseRoute} from "nuxt-spoferan/src/helpers/parse_helpers";

export default ({ app }, inject) => {
    inject('api', (name, params = {}, absolute = false) => {
        return parseRoute(ApiRoutes, name, params, null, absolute === true ? app.$config.apiUrl : absolute)
    });

    inject('web', (name, params = {}, absolute = false) => {
        return parseRoute(WebRoutes, name, params, null, absolute === true ? app.$config.appUrl : absolute)
    })
}